<ng-template #settingsTemplate>

</ng-template>
<ng-template #contentTemplate>

</ng-template>
